import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { userClearAction } from '../store/user';
import environment from '../shared/Environment';
import WelcomePosterView from './WelcomePosterView';

class ProfilePageView extends Component {
  render() {
    return (
      <Fragment>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">Profiel</div>
          <a href="mailto:support@teamaspiration.com" className="btn btn-primary ml-auto mr-2">
            <i className="fa fa-bug mr-1" /> Rapporteren
          </a>
          <button onClick={(e) => this.props.clearUser()} type="submit" className="btn btn-danger">
            Uitloggen
          </button>
        </nav>
        <WelcomePosterView />
        <div className="grid-container">
          {environment.PROFILE_URL && <iframe src={environment.PROFILE_URL} title="Dashboard" />}
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  clearUser: () => dispatch(userClearAction())
});

export default connect(null, mapDispatchToProps)(ProfilePageView);
